<template>
  <main>
    <tab-header />
    <div class="tab-content" :class="{'section-loading': initLoading}" v-show="rolePermission">
      <div class="tab-pane active show">
        <form class="form">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="float-right w-25 mt-5">
                  <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span>業務企劃科</span></div>
                  <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span>(02)27551399</span></div>
                  <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span>{{ contactInfo.contact_tel }}</span></div>
                  <button type="button" class="btn btn-primary" @click="setCeclcList()" v-show="false">設定預計回任的退休人員</button>
                  <div class="text-red font-weight-bold custom-absolute">！重要提醒！<br> 每例月前三和最後一個工作日為鎖異動期間，<br>無法進行調撥作業<br><br>離職、退休人員之服務件如涉及傳承獎金，無法透過<br>【撥出人員、保單號碼、要保人身份證字號、整合地址篩選】作業</div>
                </div>
                
                <h4 class="text-green">選擇撥出對象
                  <a
                    class="text-orange ml-4"
                    style="cursor:pointer;font-size:16px;"
                    @click="download('manager.pdf')"
                  >
                    <i class="icon-attach"></i>
                    <b>服務件調撥操作手冊</b>
                  </a>
                </h4>
                <div class="form-group row dial-form" data-index="0"
                :class="{
                  'is-select': dialOut.person !== null,
                  'active': dialOut.person !== null
                }">
                  <label class="col-3 text-right">以撥出人員篩選</label>
                  <div class="col-3">
                    <!-- :reduce="item => item.code" -->
                    <v-select :options="dialOutOpt" 
                    v-model="dialOut.person"
                    :disabled="!dialOut_person_check"
                    @search:focus="refreshHanlink('out')"
                    @search:blur="registerHanlink()"
                    placeholder="請選擇或輸入"
                    @input = "checkSmartBtnStatus"
                    alt="ch">
                      <div slot="no-options">沒有資料可供選擇 !</div>
                    </v-select>
                  </div>
                </div>
                <div class="form-group row dial-form" data-index="1"
                :class="{
                  'is-select': dialOut.insure_no !== '',
                  'active': dialOut.insure_no !== ''
                }">
                  <label class="col-3 text-right">
                    以保單號碼篩選<br/>
                    <small class="text-orange">單件快速調撥</small>
                  </label>
                  <div class="col-3">
                    <input type="text" 
                    :disabled="true"
                    v-model="dialOut.insure_no" class="form-control">
                  </div>
                  <div class="col-3">
                    <a class="btn btn-primary mt-0" @click="setFilterPlcno()">多保單篩選</a>
                  </div>
                  <div class="col-3">
                    <span class="text-green dial-form-status" v-if="insureNoCheck">
                      【{{ insureNoReturnMsg }}】
                    </span>    
                    <span class="text-rad dial-form-status" v-else>
                      {{ insureNoReturnMsg }}
                    </span>   
                  </div>
                </div>
                <div class="form-group row dial-form" data-index="2"
                :class="{
                  'is-select': dialOut.clientID !== '',
                  'active': dialOut.clientID !== ''
                }">
                  <label class="col-3 text-right">以要保人身分證字號篩選</label>
                  <div class="col-3">
                    <input type="text" 
                    :disabled="!dialOut_clientID_check"
                    v-model="dialOut.clientID" class="form-control">
                  </div>
                  <div class="col-3">
                    <span class="dial-form-status" 
                    v-if="insureIdLength > 0"
                    :class="{'text-red': !insureIdCheck,'text-green': insureIdCheck}">
                      {{ insureIdReturnMsg }}
                    </span>
                    <div v-if="insureIdLoading" class="section-loading d-inline-block" style="height:20px; width:30px"></div>
                  </div>
                </div>
                <div class="form-group row dial-form" data-index="3"
                :class="{
                  'is-select': dialOut.address[0] !== '' || dialOut.address[1] !== '' || dialOut.address[2] !== '',
                  'active': dialOut.address[0] !== '' || dialOut.address[1] !== '' || dialOut.address[2] !== ''
                }">
                  <label class="col-3 text-right">以整合地址篩選</label>
                  <div class="col-9">
                    <div class="row">
                      <div class="col-2">
                        <select  
                        :disabled="!dialOut_address_check"
                        v-model="dialOut.address[0]" 
                        @change="getDistByCity"
                        class="form-control">
                          <option value="">縣市</option>
                          <option v-for="(item, index) in Cities" :key="`addr-${index}`" :value="item.city">
                            {{ item.city }}
                          </option>
                        </select>
                      </div>
                      <div class="col-2">
                        <select  
                        :disabled="!dialOut_address_check"
                        v-model="dialOut.address[1]" class="form-control">
                          <option value="">鄉鎮市區</option>
                          <option v-for="(item, index) in distOpt" :key="`dist-${index}`" :value="item.ZIPCODE">
                            {{ item.AREA }}
                          </option>
                        </select>
                      </div>
                      <div class="col-8">
                        <input  
                        :disabled="!dialOut_address_check"
                        alt="ch"
                        v-model="dialOut.address[2]" 
                        @input = "checkSmartBtnStatus"
                        type="text" 
                        placeholder="請輸入路段名稱"  
                        class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row dial-form mb-3" data-index="4"
                :class="{
                  'is-select': dialOut.selected.length !== 0,
                  'active': dialOut.selected.length !== 0
                }">
                  <label style="padding: 0 0 0 5px;" class="col-3 text-right">以撥出類別、對象別篩選⬇︎</label>
                  <label class="col-9" style="font-weight: normal;">
                    <span v-for="(item, index) in dialOut.selected" :key="index">
                      {{ item.ceempnm }} {{item.clcno}} ; 
                    </span>
                  <button @click.prevent="dialOutDel()" 
                  v-if="dialOut.selected.length > 0" 
                  style="margin: 0 5px;" 
                  class="btn btn-red btn-sm icon-close text-red" />
                  </label>
                </div>
              </div>
            </div>
            <div class="insurance-row row">
              <table class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th>選擇</th>
                    <th>類別</th>
                    <th>撥出對象</th>
                    <th class="text-right">業務員人數<br/>(剩餘)</th>
                    <th class="text-right">服務要保人數</th>
                    <th class="text-right">應撥VIP人數<br/>(剩餘)</th>
                    <th class="text-right">應撥總人數<br/>(剩餘)</th>
                    <th class="text-right">已撥VIP人數<br/>(當月)</th>
                    <th class="text-right">已撥總人數<br/>(當月)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in outSegment" :key="`outS-${index}`">
                    <td>
                      <a v-if="dialOut_selected_check" @click="setSegmentAgnt('out' ,item.code ,item.code_nm)" class="link text-underline">選擇</a>
                    </td>
                    <td>{{ item.sort }}</td>
                    <td>{{ item.code_nm }}</td>
                    <td class="text-right">{{ item.countidno }}</td>
                    <td class="text-right">{{ item.countcust }}</td>
                    <td class="text-right">{{ item.vcount }}</td>
                    <td class="text-right">{{ item.qcount }}</td>
                    <td class="text-right">{{ item.c_vcount }}</td>
                    <td class="text-right">{{ item.c_qcount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col-12">
                <h4 class="text-green">選擇撥入對象</h4>
                <div class="row">
                  <div class="col-3 text-right mt-1">
                    <a class="btn btn-primary mt-0" @click="toSmartMatchingPage()" :disabled="!isSmartBtnEnabled">智能配對</a>                  
                  </div>
                  <div class="mt-3">
                    <a
                      class="text-orange ml-2"
                      style="cursor:pointer;font-size:16px;"
                      @click="download('智能配對調撥操作手冊v4.pdf')"
                    >
                    <i class="icon-attach"></i>
                    <b>智能配對操作說明</b>
                  </a>
                </div>
                </div>
                <div class="form-group row dial-form" data-index="5"
                :class="{
                  'is-select': dialIn.person !== null,
                  'active': dialIn.person !== null
                }">
                  <label for="" class="col-3 text-right">以撥入人員篩選</label>
                  <div class="col-3">
                    <!-- :reduce="item => item.code" -->
                    <v-select :options="dialIn_options" 
                    @search:focus="refreshHanlink('in')"
                    @search:blur="registerHanlink()"
                    v-model="dialIn.person" 
                    :disabled="!dialIn_person_check || isIntr"
                    placeholder="請選擇或輸入">
                      <div slot="no-options">沒有資料可供選擇 !</div>
                    </v-select>
                  </div>
                </div>
                <div class="form-group row dial-form mb-3" data-index="6"
                :class="{
                  'is-select': !!dialIn.selected.clcno,
                  'active': !!dialIn.selected.clcno
                }">
                  <label style="padding: 0 0 0 5px;" for="" class="col-3 text-right">以撥入類別、對象別篩選⬇︎</label>
                  <label class="col-9" style="font-weight: normal;">
                    {{ dialIn.selected.ceempnm }} {{dialIn.selected.clcno}}
                  <button @click.prevent="dialInDel()" v-if="dialIn.selected.clcno" style="margin: 0 5px;" class="btn btn-red btn-sm icon-close text-red" />                   
                  </label>
                </div>
              </div>
            </div>
            <div class="insurance-row row">
              <table class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th>選擇</th>
                    <th>類別</th>
                    <th>撥入對象</th>
                    <th class="text-right">業務員人數<br/>(剩餘)</th>
                    <th class="text-right">服務要保人數</th>
                    <th class="text-right">應撥入要保人人數<br/>(剩餘)</th>
                    <th class="text-right">已撥入要保人人數<br/>(當月)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in inSegment" :key="`inS-${index}`">
                    <td>
                      <a v-if="dialIn_selected_check" @click="setSegmentAgnt('in' ,item.code ,item.code_nm)" class="link text-underline">選擇</a>
                    </td>
                    <td>{{ item.sort }}</td>
                    <td>{{ item.code_nm }}</td>
                    <td class="text-right">{{ item.countidno }}</td>
                    <td class="text-right">{{ item.countcust }}</td>
                    <td class="text-right">{{ item.qcount }}</td>
                    <td class="text-right">{{ item.c_qcount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12 text-right">
              <div v-if="(dialOut.insure_no_List.length > 0 && !insureNoCheck) || (dialOut.clientID.length  > 0 && !insureIdCheck)" class="btn btn-primary" disabled> 
                 下一步
              </div>   
              <div v-else class="btn btn-primary" @click="summitToAnotherPage()" :disabled="isAllDisable">
                 下一步
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    
    <dial-out-person-modal 
    :open="dialOutModalOpen"
    :segmentAgntList="segmentAgntList"
    :segmentName ="segmentName"
    :resignType="doGetResignType"
    @submit="submitDialOutModal"
    @close="panelClose('dialOutModalOpen')"
    @close-resign="doCloseResignModal" />

    <dial-in-person-modal 
    :open="dialInModalOpen"
    :segmentAgntList="segmentAgntList"
    :segmentName ="segmentName"
    @submit="submitDialInModal"
    @close="panelClose('dialInModalOpen')" />

    <warning-modal
    :open="WarningModalOpen"
    :message="warningMsg"
    :showCancel="false"
    @submit="panelClose('WarningModalOpen')" />

    <ceclc-modal
    :open="ceclcModalOpen"
    :ceclcList="ceclcList"
    @submit="submitCeclcModal"
    @close="panelClose('ceclcModalOpen')" />

    <Notice-modal
    :open="NoticeModalOpen"
    :message="noticeMsg"
    @close="goNextStep"
    />  
	
    <dial-out-insurance-modal
    :open="dialOutInsuranceModalOpen"
    @submit="submitDailOutInsuranceModal"
    @close="panelClose('dialOutInsuranceModalOpen')" />

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import DialOutPersonModal from '@/desktop/components/manager/DialOutPersonModal'
import DialInPersonModal from '@/desktop/components/manager/DialInPersonModal'
import DialOutInsuranceModal from '@/desktop/components/manager/DialOutInsuranceModal'
import CeclcModal from '@/desktop/components/manager/CeclcModal'
import TabHeader from '@/desktop/components/manager/TabHeader'
import WarningModal from '@/desktop/components/WarningModal'
import NoticeModal from '@/desktop/components/NoticeModal'
import { checkInsById , getOutSegment 
, getInSegment , getSegmentAgnt , getOutAgnClcNo 
, getInAgnClcNo , queryDistByCity, downloadFile_b1, checkFinishClass, queryCeclcList, updateCeclcList, getContactInfoBySerNo, doQueryResignUnlock} from '@/service';

export default {
  name: 'TransferTab1',
  mixins: [commonMixin],
  components: {
    WarningModal, TabHeader, DialOutPersonModal, DialInPersonModal, CeclcModal, DialOutInsuranceModal, NoticeModal
  },
  watch: {
    'dialOut.clientID': function (val) {
      let pattern = /\W/g
      this.insureIdLength = val.length
      if(val != ''){
        if(pattern.test(val) == false){  // 驗證 ID 是否有數字或英文字母之外的字元
          if(val.length > 4){  // 驗證 ID 長度
            this.insureIdReturnMsg = ''
            this.doCheckInsId()
          }else{
            this.insureIdReturnMsg = '請輸入完整ID'
            this.insureIdCheck = false
          }
        }else{
          this.insureIdReturnMsg = '請輸入數字或英文字母'
          this.insureIdCheck = false
        }
      }else{
        this.insureIdReturnMsg = ''
      }
    },
  },
  computed: {
    ...mapGetters([
      'Cities'
    ]),
    dialOut_person_check () {
      return this.isAllDisable ? !this.isAllDisable : this.dialOut.insure_no === '' && 
        this.dialOut.clientID === '' && this.dialOut.address[0] === '' && this.dialOut.address[1] === '' &&
        this.dialOut.address[2] === '' && this.dialOut.selected.length == 0
    },
    dialOut_insureNo_check () {
      return this.isAllDisable ? !this.isAllDisable : this.dialOut.person === null && 
        this.dialOut.clientID === '' && this.dialOut.address[0] === '' && this.dialOut.address[1] === '' &&
        this.dialOut.address[2] === '' && this.dialOut.selected.length == 0
    },
    dialOut_clientID_check () {
      return this.isAllDisable ? !this.isAllDisable : this.dialOut.person === null && 
        this.dialOut.insure_no === '' && this.dialOut.address[0] === '' && this.dialOut.address[1] === '' &&
        this.dialOut.address[2] === '' && this.dialOut.selected.length == 0
    },
    dialOut_address_check () {
      return this.isAllDisable ? !this.isAllDisable : this.dialOut.person === null && 
        this.dialOut.clientID === '' && this.dialOut.insure_no === '' && this.dialOut.selected.length == 0
    },
    dialOut_selected_check () {
      return this.isAllDisable ? !this.isAllDisable : this.dialOut.person === null && 
        this.dialOut.clientID === '' && this.dialOut.address[0] === '' && this.dialOut.address[1] === '' &&
        this.dialOut.address[2] === '' && this.dialOut.insure_no === ''
    },
    dialIn_person_check () {
      return this.isAllDisable ? !this.isAllDisable : !this.dialIn.selected.clcno
    },
    dialIn_selected_check () {
      return this.isAllDisable ? !this.isAllDisable : this.dialIn.person === null
    },
    /** 以撥入人員篩選選項 */
    dialIn_options () {
      return this.dialIntrOpt.length > 0 ? this.dialIntrOpt : this.dialInOpt;
    },
    /** 取得離退職種類 */
    doGetResignType () {
      const resignType = this.$store.state.userInfo.divNo.substring(2, 3);
      // 1: 專招, 4: 展業
      return (resignType === "1" || resignType === "4") ? resignType : "";
    },
    /** 確認智能配對按鈕是否啟用(以撥出人員篩選有值 or 以整合地址篩選有值(完整地址) or 以撥出對象篩選有值(不包含單位服務人員、公件)  ) */
    checkSmartBtnStatus(){
      let addressStatus = this.dialOut.address.every(value => value !=='')
      let dialoutPersonStatus = this.dialOut.person !== null
      addressStatus = false        // 暫時關閉 以撥出人員篩選
      dialoutPersonStatus = false  // 暫時關閉 以整合地址篩選
      let dialoutSelectedStatus = false
      if(this.dialOut.selected.length > 0){
        const dialOutFirstData = this.dialOut.selected[0]
        if( (dialOutFirstData.is_unlock === "Y" || dialOutFirstData.is_unlock === '') && dialOutFirstData.producer_segment.toUpperCase() !== 'D' && dialOutFirstData.producer_segment.toUpperCase() !== 'X' ) {
          dialoutSelectedStatus = true
        }
      }
      this.isSmartBtnEnabled = addressStatus || dialoutPersonStatus || dialoutSelectedStatus
    }
  },
  data () {
    return {
      segmentName:'',
      dialOutObject:'',
      dialInObject:'',
      initLoading: true,
      initResCheck: [0,0,0,0],
      dialInModalOpen: false,
      dialOutModalOpen: false,
      dialOutInsuranceModalOpen: false,
      ceclcModalOpen: false,
      WarningModalOpen: false,
      NoticeModalOpen: false,
      insureNoCheck: false,
      insureIdCheck: false,
      insureNoReturnMsg: '',
      insureIdReturnMsg: '',
      warningMsg: '',
      noticeMsg:'',
      currentCode: '',
      incepsndg:'', //撥入人職級代號
      inagidno:'', //撥入人ID
      insureNoLength: 0,
      insureIdLength: 0,
      insureNoLoading: false,
      insureIdLoading: false,
      insureNoError: '',
      outSegment: [],
      inSegment: [],
      segmentAgntList: [],
      ceclcList: [],
      distOpt: [],
      distOrigin: [],
      dialOutOpt: [],
      dialInOpt: [],
      dialOut: {
        person: null,
        insure_no: '',
        insure_no_List: [],
        clientID: '',
        address: ['','',''],
        selected: [],
      },
      dialIn: {
        person: null,
        insure_no: '',
        clientID: '',
        address: ['','',''],
        selected: {},
      },
      queryData:{
        dialInName:'',
        dialInCode:'',
        condictions:{}
      },
      isAllDisable: false,
      isManager: this.$store.state.userInfo.divNo.slice(2, 3).match("1|4"),
      rolePermission: true,
      contactInfo: [],
      dialIntrOpt: [],
      isIntr: false,
      isSmartBtnEnabled: false,
      allAgents: [], //所有單位服務人員
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    refreshHanlink (val) {  // 刷新難字
      switch (val) {
        case 'out':
          this.dialOut.person = null
          break;
        case 'in':
          this.dialIn.person = null
          break;
        default:
          break;
      }
      setTimeout(() => {
        this.registerHanlink() // for 難字
      }, 200);
    },
    checkRole(){
      let roleId = this.$store.state.userInfo.roleId
      let functionId = this.$store.state.userInfo.functionId
      console.log("===== function checkRole ===== "+ " id: "+ this.$store.state.userInfo.id + "roleId: "+roleId + "functionId: "+functionId)
      if( roleId == 'SALES_MANAGER_02' || ( roleId == 'SALES_MANAGER_06' && functionId && functionId.includes('3')) ){
        this.rolePermission = true
        return true
      } else if( roleId == 'SALES_MANAGER_03' || roleId == 'SALES_MANAGER_04' || roleId == 'SALES_MANAGER_05' || roleId == 'SALES_MANAGER_06'){
        this.$router.push({ path: `/submanager/tab/1` });
        return true
      }

      this.rolePermission = false
      return false
    },
    initTransfer1 () {
      const cedvno3 = this.$store.state.userInfo.divNo.slice(0,3)
      const role_id = this.$store.state.userInfo.roleId
      // 查詢撥出各類別業務員數與已撥客戶
      getOutSegment(this.$store.state.userInfo.id, cedvno3, role_id).then(result => {
        this.initResCheck[0] = 0
        if(result && result.header.status == '200' && result.body){
          this.outSegment = result.body.segment
        }
        this.initResCheck[0] = 1
        this.checkInitLoading()
        this.registerHanlink() // for 難字
      })
      // 查詢撥入各類別業務員數與已撥客戶
      getInSegment(this.$store.state.userInfo.id, cedvno3, role_id).then(result => {
        this.initResCheck[1] = 0
        if(result && result.header.status == '200' && result.body){
          this.inSegment = result.body.segment
        }
        this.initResCheck[1] = 1
        this.checkInitLoading()
        this.registerHanlink() // for 難字
      })
      // 查詢轄下撥出人員
      getOutAgnClcNo(this.$store.state.userInfo.id, cedvno3).then(result => {
        this.initResCheck[2] = 0
        if(result && result.header.status == '200' && result.body){
          this.dialOutOpt = result.body.agents.map(item => {
            return {
              label: `${item.ceempnm || ''} ${item.clcno || ''}` ,
              code: item.clcno || '',
              agid: item.agidno || '',
              name: item.ceempnm || '',
            }
          })
        }
        this.initResCheck[2] = 1
        this.checkInitLoading()
        this.registerHanlink() // for 難字
      })
      // 查詢轄下撥入人員
      getInAgnClcNo(this.$store.state.userInfo.id, cedvno3).then(result => {
        this.initResCheck[3] = 0
        if(result && result.header.status == '200' && result.body){
          this.dialInOpt = result.body.agents.map(item => {
            return { 
              label: `${item.ceempnm || ''} ${item.clcno || ''}`,
              code: item.clcno || '',
              agid: item.agidno || '',
              name: item.ceempnm || '',
              cepsndg: item.cepsndg || ''
            }
          })
        }
        this.initResCheck[3] = 1
        this.checkInitLoading()
        this.registerHanlink() // for 難字
      })

      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })

      //是否至國泰學習網完成調訓課程
      if(this.isManager){
        const userCategoryId  = this.$store.state.userInfo.userCategoryId
        const classId = this.getClassId(userCategoryId)
        checkFinishClass(this.$store.state.userInfo.id, classId, userCategoryId).then(result => {
          if (result && result.header.status == "200" && result.body) {
            var lists = result.body.lists;
            if (lists && lists.length == 0) {
              this.warningMsg = `<h4 class="text-green">請至國泰學習網完成調訓課程，如未完成將無法使用調撥功能。
                                  </br></br>
                                  課程路徑:
                                  <a target="_blank" style="color:blue;" href='https://cathay.elearn.com.tw/dist/index.html#/courseResourceCatalog/12022?nid=20103&mid=5959'>
                                    國泰學習網/課程/業務人員課程/行銷學院/數位工具/CRM2.0
                                  </a>
                                  ，【CRM2.0】服務件調撥操作教學-經理 或 課長/組訓/區處主管版。
                                </h4>`;
              this.panelOpen("WarningModalOpen");
              
              //disable畫面功能
              this.isAllDisable = true;
            }
          }
        });
      }
    },  
    getClassId(categoryId){
      const mapping = {
        'A013': '36061',
        'A043': '36061',
        'A015': '36062',
        'A019': '36062',
        'A044': '36062',
        'A045': '36062'
      }
      return mapping[categoryId] || '';
    },
    // 設定預計回任的退休人員
    setCeclcList() {
      queryCeclcList(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo.slice(0,3)).then(result => {
        if(result && result.header.status == '200' && result.body){
          this.ceclcList = result.body.lists;
          this.panelOpen('ceclcModalOpen');
        }
      });
    },  // [預計回任] or [已回任/確定退休]
    submitCeclcModal (is_back, selectedList) {
      updateCeclcList(this.$store.state.userInfo.id, is_back, selectedList).then(result => {
        if(result && result.header.status == '200' && result.body){
          this.panelClose('ceclcModalOpen');
        }
      });
    },  // 查詢各類別人員明細
    setSegmentAgnt (type , segmentCode ,segmentName) {
      const cedvno3 = this.$store.state.userInfo.divNo.slice(0,3)
      if(type === 'out'){
        this.currentCode = segmentCode
        if (segmentCode != "A") {
          this.$store.dispatch("updateIsResignType", false);
        }
      }
      getSegmentAgnt(this.$store.state.userInfo.id, cedvno3, segmentCode).then(result => {
        if(result && result.header.status == '200' && result.body){
          this.segmentAgntList = result.body.agents
          if(segmentCode == 'D'){
            this.allAgents = this.segmentAgntList
          }
          this.segmentName = segmentName
          if(type == 'out'){
            this.panelOpen('dialOutModalOpen')
          }else if(type == 'in'){
            this.panelOpen('dialInModalOpen')
          }
        }
      })
    },
    doCheckInsId () {  // 以ID查詢服務件
      const cedvno3 = this.$store.state.userInfo.divNo.slice(0,3)
      this.insureIdLoading = true
      checkInsById(this.$store.state.userInfo.id, cedvno3, this.dialOut.clientID).then(result => {
        if(result && result.header.status == '200' && result.body){
          if(result.body.returncode == '0'){
            this.insureIdCheck = true
          }else{
            this.insureIdCheck = false
          }
          this.insureIdReturnMsg = result.body.returnmsg
        }else{
          this.insureIdCheck = false
          this.insureIdReturnMsg = '連線異常'
        }
        this.insureIdLoading = false
      })
    },
    checkInitLoading () {  // check page initial loading completed
      if(this.initResCheck.includes(0)){
        this.initLoading = true
      }else{
        this.initLoading = false
      }
    },
    submitDialOutModal (list) {  // 選取撥出對象
      let clcnoCheck = false
      list.forEach(item => {
        if(item.clcno == this.dialIn.selected.clcno){
          clcnoCheck = true
        }
        if( this.resignType !=='4' ||    this.resignType !=='1' ){
          item.is_unlock = ""
        }      
      })
      if(clcnoCheck){ // 如果撥入撥出收費代號重複
        this.warningMsg = `${this.dialIn.selected.ceempnm} 已被選取為 撥入對象，請重新選擇 所有撥出對象`
        this.panelOpen('WarningModalOpen')
      }else{
        this.panelClose('dialOutModalOpen')
        this.dialOut.selected = []
        const vm = this
        setTimeout(() => {
          vm.dialOut.selected = [...list]
        }, 100);
      }
    },
    submitDialInModal (obj) {  // 選取撥入對象
      let clcnoCheck = false
      this.dialOut.selected.forEach(item => {
        if(item.clcno == obj.clcno){
          clcnoCheck = true
        }
      })
      if(clcnoCheck){ // 如果撥入撥出收費代號重複
        this.warningMsg = `${obj.ceempnm} 已被選取在 所有撥出對象內，請重新選擇 撥入對象`
        this.panelOpen('WarningModalOpen')
      }else{
        this.panelClose('dialInModalOpen')
        // for 難字更新
        this.dialIn.selected = {}
        setTimeout(() => {
          this.dialIn.selected = {...obj}
        }, 100);
      }
    },
    async getDistByCity () {  // 取得由郵遞區號跟名稱
      this.dialOut.address[1] = ""
      const distdata = await queryDistByCity(this.$store.state.userInfo.id, this.dialOut.address[0])
      if(distdata && distdata.header && distdata.header.status === '200'){
        this.distOpt = distdata.body.cityAreaList
      }
    },
    dialOutDel(){ //清除撥出已選擇項目
      this.dialOut.selected = []
    },
    dialInDel(){
      this.dialIn.selected =''
    },
    setQueryData(){
      var commit_check = false
      var dialInCheck = false
      var dialOutCheck = false
      var code = ''
      const cedvno = this.$store.state.userInfo.divNo.slice(0,3)
      //判斷撥入人員類別
      if(this.dialIn.person != null){
        console.log("dialIn.preson");
        this.inagidno = this.dialIn.person.agid;
        this.incepsndg = this.dialIn.person.cepsndg;
        code = this.dialIn.person.code
        dialInCheck = true
      }
      if(this.dialIn.selected.ceempnm){
        console.log("dialIn.selected");
        this.inagidno = this.dialIn.selected.agidno;
        this.incepsndg = this.dialIn.selected.cepsndg;
        code = this.dialIn.selected.clcno
        dialInCheck = true
      }

      if(this.dialOut.person != null){
        console.log('type = 1')  
        // this.queryData.dialIn = this.dialIn.person
        // this.queryData.dialOut = this.dialOut.person
        this.queryData.condictions = {
          type: "1",
          cedvno3: cedvno,
          clcno_old: this.dialOut.person.code,
          clcno_new: code,
          inagidno: this.inagidno,
          incepsndg: this.incepsndg
        }
        dialOutCheck = true
        commit_check = true
      }
      
      if(this.dialOut.insure_no != ''){
        console.log('type = 2')
        this.queryData.condictions = {
          type: "2",
          cedvno3: cedvno,
          clcno_new: code,
          inagidno: this.inagidno,
          incepsndg: this.incepsndg,
          selectedPlcno: this.dialOut.insure_no_List.map(ele => ele.ceplcno)
        }
        dialOutCheck = true
        commit_check = true
      }
      
      if(this.dialOut.clientID != ''){
        console.log('type = 3')
        this.queryData.condictions = {
          type: "3",
          cedvno3: cedvno,
          ceapcno: this.dialOut.clientID,
          clcno_new: code,
          inagidno: this.inagidno,
          incepsndg: this.incepsndg
        }
        dialOutCheck = true
        commit_check = true
      }
      
      if(this.dialOut.address[0] != '' || this.dialOut.address[1] != '' || this.dialOut.address[2] != ''){
        console.log('type = 4')
        if(this.dialOut.address[0] != '' && this.dialOut.address[1] != '' && this.dialOut.address[2] != ''){
          this.queryData.condictions = {
            type: "4",
            cedvno3: cedvno,
            zip: this.dialOut.address[1],
            addr: this.dialOut.address[2],
            clcno_new: code,
            inagidno: this.inagidno,
            incepsndg: this.incepsndg
          }
          dialOutCheck = true
          commit_check = true
        } else{
          this.$toast.info({title:'請輸入完整地址路段名稱!'})
        }
      }
      
      if(this.dialOut.selected.length > 0){
        console.log('type = 5')
        let clcnoList = []
        this.dialOut.selected.forEach(data =>{
          clcnoList.push({
            segment_s: data.producer_segment,  //  選取的撥出類別
            clcno_s: data.clcno,  //  選取的撥出代號
          })
        })
        console.log(clcnoList);
        
        this.queryData.condictions = {
          type: "5",
          cedvno3: cedvno,
          clcno_new: code,

          //TODO 需取MXB1_1004的code(類別代號)
          segment_clcno: clcnoList,
          inagidno: this.inagidno,
          incepsndg: this.incepsndg
        }
        dialOutCheck = true
        commit_check = true
      }
      if(dialInCheck == false && dialOutCheck == false){
        commit_check = false
        this.$toast.info({title:'請選取撥出/撥入人員'})
      } else{
        if(dialInCheck == false){
          commit_check = false
          this.$toast.info({title:'請選取撥入人員'})
        }
        if(dialOutCheck == false){
          commit_check = false
          this.$toast.info({title:'請選取撥出人員'})
        }
      }
      return commit_check
    },
    summitToAnotherPage(){ //導頁至服務件列表
      const check = this.setQueryData()
      
      if(this.dialIn.person !== null){  // 以撥入人員篩選時
        this.queryData.dialInName = this.dialIn.person.name
        this.queryData.dialInCode = this.dialIn.person.code
      }else{  // 以撥入類別、對象別篩選⬇︎時
        this.queryData.dialInName = this.dialIn.selected.ceempnm
        this.queryData.dialInCode = this.dialIn.selected.clcno
      }
      if(check){
        if (this.queryData.condictions.type == '1' && this.queryData.condictions.clcno_new == this.queryData.condictions.clcno_old) { 
          return this.$toast.info({title: '選擇撥出與撥入同仁有重覆，請再次確認!'})
        } else if (this.queryData.condictions.type == '5') { 
          let compareAry = this.queryData.condictions.segment_clcno.map(item => {return item.clcno_s})
          if (compareAry.includes(this.queryData.condictions.clcno_new)) {
            return this.$toast.info({title: '選擇撥出與撥入同仁有重覆，請再次確認!'})
          }
        } else if(this.queryData.condictions.type == '2') {
          let msg = '';
          let checkCode = this.queryData.dialInCode;
          this.dialOut.insure_no_List.forEach(item => {
            if (item.ceclcno == checkCode) {
              msg += item.ceplcno + ', '
            }
          })
          if (msg) {
            this.$toast.info({title: '選擇撥出與撥入同仁有重覆，請再次確認! 保單號碼: ' + msg.substring(0, msg.length - 2)});
            return;
          }
        }

        //若撥入人員為CA，跳出提示視窗
        if(this.incepsndg == 'OT' || this.incepsndg == 'OJ' || this.incepsndg == 'OG') {
          this.noticeMsg = "<h2 class='text-green'>注意事項</h2><b>你選擇的撥入對象為『CA人員』，故在保單調撥畫面僅會顯示<span class='text-red'>『該CA人員招攬的保單』</span>，供主管調撥。</b>";
          this.NoticeModalOpen = true;
        } else {
          this.goNextStep();
        }
      }
    },
    download (file_name) {
      let vm = this;
      downloadFile_b1(this.$store.state.userInfo.id, 1, file_name).then(
        result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, file_name);
          }
        }
      );
    },
    goNextStep () {
      this.$store.dispatch('setRouterPara', {pathName:'managerTabOne', setData: this.queryData})
      this.$router.push({ path: '/manager/tab/1/filter' })
	  },
    setFilterPlcno() {
      // 開啟多保單篩選Modal
      this.panelOpen('dialOutInsuranceModalOpen');
    },
    submitDailOutInsuranceModal(list) {
      // 設定多保單篩選
      if (list && list.length > 0) {
        this.dialOut.insure_no = list.map(ele=>ele.policyNumber).join(',');
        this.dialOut.insure_no_List = list;
        this.insureNoCheck = true;
        this.insureNoReturnMsg = "檢核正確"
      } else {
        this.dialOut.insure_no = ""
        this.dialOut.insure_no_List = [];
        this.insureNoCheck = false;
        this.insureNoReturnMsg = "";
      }

      this.panelClose('dialOutInsuranceModalOpen');
    },
    /**
     * 查詢離退人員對應增員者是否解鎖
     * @param {Object} selection 撥出對象
     */
    doCloseResignModal(selection) {
      // this.dialOut.selected = [...selection];
      // this.panelClose("dialOutModalOpen");
      this.dialIntrOpt = [];
      this.dialIn.person = null;
      this.isIntr = false;
      if (this.$store.state.isQryResginUnlock) {
        doQueryResignUnlock(
          this.$store.state.userInfo.id,
          this.$store.state.resignInfo.resign_id,
          this.$store.state.resignInfo.intr_id
        ).then((result) => {
          if (result && result.header.status == "200" && result.body) {
            if (result.body.is_unlock === "N") {
              const resignInfo = this.$store.state.resignInfo;
              const intrOpt = {
                label: `${resignInfo.intr_name || ''} ${resignInfo.intr_ceclcno || ''}`,
                code: resignInfo.intr_ceclcno || '',
                agid: resignInfo.intr_id || '',
                name: resignInfo.intr_name || '',
                cepsndg: ''
              }
              this.dialIntrOpt = [{...intrOpt}];
              this.dialIn.person = intrOpt;
              this.isIntr = true;
            }
            this.dialOut.selected = [...selection]; 
          }
        });
      }else{
        selection.forEach( item => item.is_unlock = '' )
        this.dialOut.selected = [...selection];
      }
      this.panelClose("dialOutModalOpen");
      this.$store.dispatch("updateIsQryResginUnlock", false);
    },
    async toSmartMatchingPage() {
      if(!this.isSmartBtnEnabled)
       return

      await this.queryAllAgents();
      setTimeout(()=>{
        let dialOut = {
          type: '',
          resignType: this.doGetResignType,
          resignStatus: '',
          data: null,
          allAgents: this.allAgents
        };
        if( this.dialOut.person !== null ){
          dialOut.type = '1'; //'person'
        }else if( this.dialOut.person == null && this.dialOut.address.length !== 0 && this.dialOut.selected.length == 0 ){
          dialOut.type = '4'; // 'address'
        }else if( this.dialOut.selected.length !==0 ){
          dialOut.type = '5'; //'selected'
        }
        dialOut.data = this.dialOut
        //選擇撥出人員為專招-離職人員，clcno需要代入選取之離職人員的resign_ceclcno
        if( dialOut.resignType == '1' && dialOut.data.selected.length !== 0 ){
          if(dialOut.data.selected[0].producer_segment == 'A'){
            dialOut.resignStatus = '1A'; //特別標註為專招之離職人員
            const resignInfo=  this.$store.state.resignInfo
            dialOut.data.selected[0].resign_ceclcno = resignInfo.resign_ceclcno
            dialOut.data.selected[0].resign_id = resignInfo.resign_id
            dialOut.data.selected[0].resign_name = resignInfo.resign_name
          }
        }
        this.$store.dispatch('setRouterPara', {pathName:'dialOutData', setData: dialOut})
        this.$router.push({path: `/manager/tab/1/smartMatching`})
      },100)

    },
    async queryAllAgents(){
      const cedvno3 = this.$store.state.userInfo.divNo.slice(0,3)
      await getSegmentAgnt(this.$store.state.userInfo.id, cedvno3, "D").then(result => {
        if(result && result.header.status == '200' && result.body){
            this.allAgents = result.body.agents;
        }
      })
    }
  },
  mounted () {
    if(!this.checkRole()){
        this.$toast.info({ title: '無該畫面權限' })
        return
    }
    this.initTransfer1()
  }
}
</script>
<style scoped>
.custom-absolute{
  position: absolute;
  right: 10px;
}
</style>
